import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 bg-orange-100/60 border-t border-orange-200 text-center" data-id="element-121">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-122">
        <div className="bg-white p-4 rounded-lg border border-orange-200 inline-block shadow-sm" data-id="element-123">
          <p className="text-slate-700 font-medium text-sm" data-id="element-124">
            PRODUCTO DIGITAL · Este producto es digital y se envía
            automáticamente después de la compra.
          </p>
          <p className="text-slate-500 text-xs mt-1" data-id="element-125">
            Acceso inmediato. Descarga en PDF. Acceso de por vida.
          </p>
        </div>

        <div className="text-slate-600 text-sm space-y-2" data-id="element-126">
          <p data-id="element-127">© 2024 Mente Activa. Todos los derechos reservados.</p>
          <p className="space-x-4" data-id="element-128">
            <a href="#" className="hover:text-teal-700 transition-colors" data-id="element-129">
              Términos y Condiciones
            </a>
            <span data-id="element-130">·</span>
            <a href="#" className="hover:text-teal-700 transition-colors" data-id="element-131">
              Política de Privacidad
            </a>
            <span data-id="element-132">·</span>
            <a href="#" className="hover:text-teal-700 transition-colors" data-id="element-133">
              Contacto
            </a>
          </p>
        </div>

        <p className="text-slate-500 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-134">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}